import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  centered?: boolean;
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  color = 'blue',
  centered = true,
  text = 'Loading...'
}) => {
  const spinnerSize = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  const spinnerColor = {
    blue: 'border-blue-500',
    green: 'border-green-500',
    red: 'border-red-500',
    yellow: 'border-yellow-500',
    gray: 'border-gray-500'
  };

  return (
    <div className={`flex items-center ${centered ? 'justify-center' : ''}`}>
      <div className={`${spinnerSize[size]} border-4 ${spinnerColor[color as keyof typeof spinnerColor] || 'border-blue-500'} border-t-transparent rounded-full animate-spin`} role="status">
        <span className="sr-only">{text}</span>
      </div>
      {text && <span className="ml-2">{text}</span>}
    </div>
  );
};

export default LoadingSpinner;
